import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { orderHistory } from '../redux/actions/user';
import { Redirect } from 'react-router-dom';
import { formatPrice, itemNamewithAddonV1 } from '../common/Functions';

function Orders({ orders, orderHistory }) {
    const [close, SetClose] = useState(false);

    useEffect(() => {
        orderHistory();
    }, [])


    function convertDate(order) {
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let d = new Date(order.order_info.transaction_date);
        return months[d.getMonth()];
    }

    function convertDay(order) {
        let d = new Date(order.order_info.transaction_date);
        return d.getDate();
    }



    if (close) {
        return <Redirect to="/" />
    }



    return (
        <>
            <header className="fixed header-blue">
                <div className="container">
                    <div className="header-top">
                        <div className="header-top-left">
                            <span className="back"><img className="img-dark" src="images/arrow-back.png" alt="" />
                                <img className="img-white" src="images/arrow-back-white.png" alt="" onClick={() => SetClose(true)} />
                            </span>
                        </div>
                        <div className="header-top-mid">
                            <span className="font-semibold">Past Orders</span>
                        </div>
                        <div className="header-top-right"></div>
                    </div>
                </div>
            </header>
            {orders.length > 0 && <div className="previous-orders-main" style={{ marginTop: "51px" }}>
                <div className="previous-order-list">
                    {orders.map(order => (<div className="previous-order-item" key={order.order_info.order_id}>
                        <div className="previous-order-item-head text-white active">
                            <div className="order-date  text-center">
                                <span className="fa fa-calendar"></span>
                                <span className="month-name">{convertDate(order)}</span>
                                <span className="date font-bold">{convertDay(order)}</span>
                            </div>
                            <span className="resturant-name">{order.order_info.order_id}</span>

                        </div>
                        <div className="order-content active">
                            <div className="previous-order-info">
                                <div className="completed-order mt-25">
                                    <div className="order-full-details mt-25">
                                        <div className="row font-semibold">
                                            <div className="col-6">Items Ordered:</div>
                                            <div className="col-6 text-right">Amount</div>
                                        </div>
                                        {order.cart.cart_content.map((item, index) => (<div className="row mt-5" key={index}>
                                            <div className="col-6">{item.qty} x {itemNamewithAddonV1(item)}</div>
                                            <div className="col-6 text-right">{formatPrice(item.total)}</div>
                                        </div>))}

                                        <div className="bill-calculations border-top">
                                            <div className="bill-top ">
                                                <div className="row">
                                                    <div className="col-6">Item Total</div>
                                                    <div className="col-6 text-right">{formatPrice(order?.cart?.subtotal?.amount_pretty)} </div>
                                                </div>
                                                {order?.cart?.discount?.map((extra, index) => <div className="row" key={index}>
                                                    <div className="col-6">{extra.type}</div>
                                                    <div className="col-6 text-right">{formatPrice(extra.amount_pretty)}</div>
                                                </div>)}
                                                {order?.cart?.extra?.map((extra, index) => <div className="row" key={index}>
                                                    <div className="col-6">{extra.type}</div>
                                                    <div className="col-6 text-right">{formatPrice(extra.amount_pretty)}</div>
                                                </div>)}
                                            </div>
                                            <div className="grand-total-calculation ">
                                                <div className="row">
                                                    <div className="col-6 font-semibold">Grand Total</div>
                                                    <div className="col-6 text-right font-semibold">{formatPrice(order.cart.grand_total.amount_pretty)}</div>
                                                </div>
                                            </div>
                                            <div className="payment-details mt-25">
                                                <h3>Payment Details </h3>
                                                <p className="small">Payment Mode:</p>
                                                <p>{order.order_info.payment_type}</p>
                                                <p className="small">Order Status:</p>
                                                <p>{order.order_info.status}</p>
                                            </div>

                                            {/*<div className="card-details mt-10">
                                                <p className="small">Payment Mode:</p>
                                                <p>HDFC Debit Card 3126 7xxxx xxxx xxxx</p>
                                            </div>
                                            <div className="mt-55">
                                                <a className="text-pink" href="#">View bill</a>
    </div>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>))}
                </div>
            </div>}
        </>
    )
}

const mapStateToProps = (state) => ({
    orders: state.user.orderHistory
})

export default connect(mapStateToProps, { orderHistory })(Orders)
